import { configureStore} from "@reduxjs/toolkit";
import { createReduxHistoryContext } from "redux-first-history";
import { composeWithDevTools } from "@redux-devtools/extension";
import { createHashHistory } from "history";

// reducers
import settings from "../reducers/settings";
import testerReducer from "features/storetester/tester";
import menudata from "reducers/menudata/menudata";
import orderdata from "reducers/orderdata/orderdata";
import appdata from "reducers/appdata/appdata";
import menuitem from "reducers/menuitem/menuitem";
import scheduledata,{scheduledata_setCurrentWeekNumber} from "reducers/scheduledata/scheduledata";

// https://github.com/salvoravida/redux-first-history

const { createReduxHistory, routerReducer } = createReduxHistoryContext({
  history: createHashHistory()
});

const reducer = {
  router: routerReducer,
  settings: settings,
  tester: testerReducer,
  menudata: menudata,
  menuitem: menuitem,
  scheduledata:scheduledata,
  orderdata:orderdata,
  appdata:appdata
};

export const store = configureStore({
  reducer: reducer,
  enhancer: [composeWithDevTools()]
});

export const history = createReduxHistory(store);
